import { render, staticRenderFns } from "./AdminCreateModal.vue?vue&type=template&id=be446e88&scoped=true"
import script from "./AdminCreateModal.vue?vue&type=script&lang=js"
export * from "./AdminCreateModal.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateModal.vue?vue&type=style&index=0&id=be446e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be446e88",
  null
  
)

export default component.exports